/**
 * Ítems que MU Vanguard no utiliza. Se quitan de la guía al cargar los datos
 * (catálogo, variantes, rutas, buscador y fichas). Para volver a mostrar uno, borra su patrón.
 *
 * `basis` documenta el origen de cada exclusión:
 * - 'staff': hay una instrucción explícita del staff que la respalda (se cita).
 * - 'pending': filtro sin instrucción explícita → pendiente de aprobación editorial.
 */
type ExclusionRule = { label: string; pattern: RegExp; basis: 'staff' | 'pending'; instruction?: string }

const STAFF_INSTRUCTION = 'Instrucción del staff en el chat de edición, sobre los pases por tiempo y los Lucky Tickets: "ELIMINA ESOS ITEMS DE LA BASE DE DATOS Y DE AHI, NO LOS USAREMOS"'

export const excludedItemPatterns: ExclusionRule[] = [
  { label: 'Pases por tiempo (3-Hour Pass, 30-Day Pass, 90-Day Pass - Points…)', pattern: /^\s*\d+\s*-\s*(hour|day)s?\s+pass\b/i, basis: 'staff', instruction: STAFF_INSTRUCTION },
  { label: 'Lucky Tickets (1st / 2sd Lucky Armor, Boots, Gloves, Helm, Pants Ticket…)', pattern: /\blucky\b.*\bticket\b/i, basis: 'staff', instruction: STAFF_INSTRUCTION },
]

/**
 * Retirados de esta versión por ID exacto: 40 ítems sin archivo gráfico correspondiente en Item.zip.
 * Nombres del catálogo Vanguard recibido. No implica que estén desactivados en el servidor.
 */
const NO_GRAPHIC_INSTRUCTION = 'Instrucción del staff: "esos items no los pongas en esta versión, elimínalos por ahora" — 40 ítems sin archivo gráfico correspondiente en Item.zip (no implica que estén desactivados)'
export const excludedNoGraphicIds: Record<string, string> = {
  '4,25': 'Angelic Bow', '4,26': 'Devil Crossbow',
  '7,221': 'Manticore Knight Helm', '7,227': 'Manticore Fighter Helm', '7,233': 'Manticore Knight Helm [Belief]',
  '12,26': 'Gem of Secret',
  '13,19': 'Absolute Weapon of Archangel', '13,20': 'Wizards Ring',
  '13,83': 'Talisman of Wings of Satan', '13,84': 'Talisman of Wings of Heaven', '13,85': 'Talisman of Wings of Elf',
  '13,86': 'Talisman of Wing of Curse', '13,87': 'Talisman of Cape of Emperor', '13,88': 'Talisman of Wings of Dragon',
  '13,89': 'Talisman of Wings of Soul', '13,90': 'Talisman of Wings of Spirits', '13,91': 'Talisman of Wing of Despair',
  '13,92': 'Talisman of Wings of Darkness', '13,95': "Gladiator's Honor", '13,96': 'Seal of Strength',
  '13,117': 'Minimum Vitality Potion', '13,118': 'Low Vitality Potion', '13,119': 'Medium Vitality Potion', '13,120': 'High Vitality Potion',
  '13,131': 'Maple Charm', '13,133': 'Golden Maple Charm',
  '14,55': 'Green Chaos Box', '14,56': 'Red Chaos Box', '14,57': 'Purple Chaos Box', '14,125': 'Package Box',
  '14,169': 'Rage Fighter Character Card',
  '14,244': 'Jewel Of Level', '14,245': 'Jewel Of Skill', '14,246': 'Jewel Of Luck', '14,247': 'Jewel Of Adicional',
  '14,248': 'Jewel Of Excelentt', '14,249': 'Jewel Of Socket', '14,250': 'Jewel Of Ancient 1', '14,251': 'Jewel Of Ancient 2',
  '14,252': 'Jewel Of full',
}

export const isExcludedItemName = (name: string) => excludedItemPatterns.some((p) => p.pattern.test(name))

/** Motivo de exclusión con el filtro aplicado y su origen (para el panel), o undefined si el ítem se publica. */
export const excludedItemReason = (name: string, id?: string) => {
  if (id && excludedNoGraphicIds[id.trim()] !== undefined)
    return `Sin archivo gráfico en Item.zip (retirado de esta versión) · filtro por ID exacto ${id} · origen: Decisión del staff — ${NO_GRAPHIC_INSTRUCTION}`
  const p = excludedItemPatterns.find((x) => x.pattern.test(name))
  if (!p) return undefined
  const basis = p.basis === 'staff' ? `Decisión del staff — ${p.instruction}` : 'Pendiente de aprobación editorial (sin instrucción explícita)'
  return `${p.label} · filtro de nombre ${p.pattern} · origen: ${basis}`
}
